import { trace } from 'rytm-helpers';

export const initModal = () => {
  const modal = document.documentElement.querySelector('.wmodal-modal');
  if (modal) {
    $(modal).modal('show');
    $(modal).on('hide.bs.modal', onDocModalHide);
  }

}


const onDocModalHide = (e) => {
  const key = e.target.dataset.cookieName;
  const timeSeconds = e.target.dataset.cookieTime;
  if (key && timeSeconds) {
    let date = new Date();
    const time = date.getTime();
    date.setTime(time + (timeSeconds*1000));
    document.cookie = key + "=" + time + "; expires=" + date.toGMTString() + "; path=/";
  }
}